import { render, staticRenderFns } from "./Postcode.vue?vue&type=template&id=1a3625c0&scoped=true&"
import script from "./Postcode.vue?vue&type=script&lang=js&"
export * from "./Postcode.vue?vue&type=script&lang=js&"
import style0 from "./Postcode.vue?vue&type=style&index=0&id=1a3625c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3625c0",
  null
  
)

export default component.exports